




























import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { namespace } from "vuex-class";
import StudentRequestMixin from "@/mixins/Request/StudentRequestMixin";
import FscPageHeader from "@/components/FscPageHeader.vue";
import { ITenstarSimulatorStudent } from "@/interfaces/ITenstarSimulatorStudent";
import SaveButton from "@/components/Button/SaveButton.vue";
import SimulatorFormCard from "@/views/Student/Simulator/SimulatorFormCard.vue";

const SimulatorTenStarStudentModule = namespace("simulator-ten-star-student");

@Component({
  components: { SimulatorFormCard, SaveButton, FscPageHeader },
})
export default class Simulator extends mixins(StudentRequestMixin) {
  public name = "Simulator";

  public dataLoaded = false;
  private hasTenstarSimulatorAccount = false;

  public formData: ITenstarSimulatorStudent = {
    firstName: "",
    lastName: "",
    email: "",
  };

  @SimulatorTenStarStudentModule.Action("checkHasAccount")
  public checkHasTenstarAccount: any;

  @SimulatorTenStarStudentModule.Action("fetchSimulatorStudent")
  public fetchTenstarSimulatorStudent: any;

  @SimulatorTenStarStudentModule.Getter("getDataItem")
  public tenstarSimulatorStudent: any;

  @SimulatorTenStarStudentModule.Getter("getIsLoading")
  public loading: any;

  @SimulatorTenStarStudentModule.Getter("getSuccess")
  public success: any;

  @SimulatorTenStarStudentModule.Action("createStudent")
  public createTenstarSimulatorStudent: any;

  @SimulatorTenStarStudentModule.Action("updateStudent")
  public updateTenstarSimulatorStudent: any;

  public get studentId() {
    return this.student.id;
  }

  public get studentName() {
    if (this.student) {
      return this.student.firstName + " " + this.student.lastName;
    }
    return "<Vorname> <Nachname>";
  }

  public async handleSave(data: any) {
    await this.createTenstarSimulatorStudent({ studentId: this.studentId, studentData: data });

    if (this.success) {
      this.$toasted.success(this.$t("messages.save_success").toString());
      this.hasTenstarSimulatorAccount = true;
      this.formData = { ...data };
    }
  }

  public async handleUpdate(data: any) {
    await this.updateTenstarSimulatorStudent({ studentId: this.studentId, studentData: data });
    if (this.success) {
      this.$toasted.success(this.$t("messages.save_success").toString());
      this.formData = { ...data };
    } else {
      this.initForm();
    }
  }

  public initForm() {
    const source = this.hasTenstarSimulatorAccount ? this.tenstarSimulatorStudent : this.student;

    this.formData = {
      firstName: source?.firstName || "",
      lastName: source?.lastName || "",
      email: source?.email || "",
    };
  }

  public async mounted() {
    await this.fetchStudent(Number(this.$route.params.id));

    this.hasTenstarSimulatorAccount = await this.checkHasTenstarAccount({ studentId: this.studentId });
    if (this.hasTenstarSimulatorAccount) {
      await this.fetchTenstarSimulatorStudent({ studentId: this.studentId });
    }

    await this.$nextTick();

    this.initForm();
    this.dataLoaded = true;
  }
}
